import { InventoryCategory } from './InventoryCategory';

export class InventoryRecap {
  constructor(
    private readonly algorithms: InventoryCategory[],
    private readonly keys: InventoryCategory[],
    private readonly keystores: InventoryCategory[],
    private readonly operations: InventoryCategory[]
  ) {
    this.algorithms = algorithms || [];
    this.keys = keys || [];
    this.keystores = keystores || [];
    this.operations = operations || [];
  }

  getAlgorithms() {
    return this.algorithms;
  }

  getKeys() {
    return this.keys;
  }

  getKeystores() {
    return this.keystores;
  }

  getOperations() {
    return this.operations;
  }

  isEmpty() {
    return this.getAlgorithms().length + this.getKeys().length + this.getKeystores().length + this.getOperations().length === 0;
  }

  static getBlank() {
    return new InventoryRecap([], [], [], []);
  }
}
